import { getSelectCustomStyles } from "@ui/components/inputs/select/getSelectCustomStyles";
import { Maybe, MaybeUndef } from "shared";
import ReactSelect, {
  ActionMeta,
  MenuPlacement,
  SingleValue,
  StylesConfig,
} from "react-select";
import { ColorValue } from "@ui/types/enums/ColorValue";
import { TriangleDown } from "@ui/components/icons/TriangleDown";

function CustomDropdownIndicator() {
  return (
    <div style={{ paddingRight: 24 }}>
      <TriangleDown colorValue={ColorValue.Primary} />
    </div>
  );
}

type Option = { label: string; value: string };

type Props = {
  customStyles?: StylesConfig<{ label: string; value: string }, false>;
  defaultValue?: MaybeUndef<Option>;
  hasError?: boolean;
  height?: number;
  isDisabled?: boolean;
  menuPlacement?: MenuPlacement;
  onChange: (value: SingleValue<Option>, action: ActionMeta<Option>) => void;
  options: Array<Option>;
  placeholder: string;
  showCursor?: boolean;
  value?: Maybe<Option>;
};

/**
 * A react-select component with custom styling.
 */
export function Select({
  customStyles,
  defaultValue,
  hasError = false,
  height,
  isDisabled = false,
  menuPlacement = "auto",
  onChange,
  options,
  placeholder,
  value,
  showCursor,
}: Props): JSX.Element {
  return (
    <div>
      <ReactSelect
        components={{
          DropdownIndicator: CustomDropdownIndicator,
          IndicatorSeparator: () => null,
        }}
        defaultValue={defaultValue}
        isDisabled={isDisabled}
        menuPlacement={menuPlacement}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        styles={{
          ...getSelectCustomStyles({
            hasError,
            height: height ?? 52,
            showCursor,
          }),
          ...customStyles,
        }}
        value={value}
      />
    </div>
  );
}
